<script>
export default {
  props: {
    title: { type: String, required: true },
    value: { type: [String, Number], default: '' },
    compact: { type: Boolean, default: false },
  },
};
</script>

<template>
  <!-- Mesmo padrão da linha de atributo: rótulo numa linha, valor abaixo. -->
  <div
    class="flex items-start gap-2.5"
    :class="compact ? 'mb-2 py-0' : 'mb-2 py-0.5 last:mb-0'"
  >
    <div class="flex min-w-0 flex-1 flex-col gap-0.5">
      <span
        class="min-w-0 truncate text-[12.5px] leading-snug text-n-slate-11"
        :title="title"
      >
        {{ title }}
      </span>
      <div
        v-if="value || $slots.default"
        class="min-w-0 truncate text-[13.5px] font-medium leading-snug text-n-slate-12"
        :title="value ? String(value) : undefined"
      >
        <slot>
          {{ value }}
        </slot>
      </div>
    </div>
    <div class="flex shrink-0 items-center">
      <slot name="button" />
    </div>
  </div>
</template>
